// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Heph","name":"styles_name__2HQv0","phone":"styles_phone__24WN3"};